import { render, staticRenderFns } from "./mod8.vue?vue&type=template&id=39b660ff&scoped=true&"
import script from "./mod8.vue?vue&type=script&lang=js&"
export * from "./mod8.vue?vue&type=script&lang=js&"
import style0 from "./mod8.vue?vue&type=style&index=0&id=39b660ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b660ff",
  null
  
)

export default component.exports